export default __webpack_public_path__ + "static/media/img-0341-ukraine-full-face.1586578f.png";